export var LimitTypes;
(function (LimitTypes) {
    LimitTypes["NONE"] = "NONE";
    LimitTypes["AMOUNT"] = "AMOUNT";
    LimitTypes["TIME"] = "TIME";
})(LimitTypes || (LimitTypes = {}));
//# sourceMappingURL=limit-settings.js.map